// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-link{
    text-decoration: none;
    cursor: pointer;
}
.navigation-list{
    /* background-color: #FEFDED; */
}`, "",{"version":3,"sources":["webpack://./src/components/navigation/navigationList.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,+BAA+B;AACnC","sourcesContent":[".navigation-link{\n    text-decoration: none;\n    cursor: pointer;\n}\n.navigation-list{\n    /* background-color: #FEFDED; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
